// store.js
import { reactive } from 'vue';

export const store = reactive({
  user: {},
  role: 'guest'
});
